import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
    KEY_ENTER_COMMAND,
    INSERT_PARAGRAPH_COMMAND,
    INSERT_LINE_BREAK_COMMAND,
    COMMAND_PRIORITY_HIGH,
} from 'lexical';

export function BlockSlotEnterPlugin({
    onEnter,
    onShiftEnter,
}: {
    onEnter?: () => void;
    onShiftEnter?: () => void;
}) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        const unregisterParagraph = editor.registerCommand(
            INSERT_PARAGRAPH_COMMAND,
            () => true,
            COMMAND_PRIORITY_HIGH
        );
        const unregisterLineBreak = editor.registerCommand(
            INSERT_LINE_BREAK_COMMAND,
            () => true,
            COMMAND_PRIORITY_HIGH
        );
        const unregisterKeyEnter = editor.registerCommand(
            KEY_ENTER_COMMAND,
            (event?: KeyboardEvent) => {
                if (event && event.shiftKey) {
                    onShiftEnter?.();
                } else {
                    onEnter?.();
                }
                return true;
            },
            COMMAND_PRIORITY_HIGH
        );
        return () => {
            unregisterParagraph();
            unregisterLineBreak();
            unregisterKeyEnter();
        };
    }, [editor, onEnter, onShiftEnter]);

    return null;
}

interface BlockEnterPluginProps {
    override?: boolean;
}

/* ===================== Block Enter Plugin for Main Editor ===================== */
export function BlockEditorEnterPlugin({ override = false }: BlockEnterPluginProps) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (override) return; // Do not unregister anything if override is true

        // Block paragraph insertion
        const unregisterParagraph = editor.registerCommand(
            INSERT_PARAGRAPH_COMMAND,
            () => true, // Return true to prevent default behavior
            COMMAND_PRIORITY_HIGH
        );

        // Block line break insertion
        const unregisterLineBreak = editor.registerCommand(
            INSERT_LINE_BREAK_COMMAND,
            () => true, // Return true to prevent default behavior
            COMMAND_PRIORITY_HIGH
        );

        // Block Enter key
        const unregisterKeyEnter = editor.registerCommand(
            KEY_ENTER_COMMAND,
            () => true, // Return true to prevent default behavior
            COMMAND_PRIORITY_HIGH
        );

        return () => {
            unregisterParagraph();
            unregisterLineBreak();
            unregisterKeyEnter();
        };
    }, [editor, override]);

    return null;
}
